<template>
  <div v-if="_isShow" class="page-wrapper page-fixed select">
        <ul class="page-background-color-white padding30 page-absolute select-option-wrapper" :class="{'twoTypesStyle':twoTypes}">
            <li v-if="!twoTypes" v-for="(val, ind) in id_type_arr" :key="ind" class="select-option" @click="checkedOption(val)">
                <span class="circular" :class="{'checked-option': (checked_option == val.value)}">
                </span> <span>{{val.text}}{{addTextWords}}</span>
            </li>
            <li v-if="twoTypes" v-for="(val, ind) in id_type_arr" :key="ind" class="select-option page-margin-bottom2" @click="checkedOption(val)">
                
                <div class='ciCard'>
                    <span class="circular page-absolute quan" :class="{'checked-option': (checked_option == val.value)}">
                </span>
                    <div class="cardNum">
                        券号<br>
                        {{val.coupon_title}}
                    </div>
                    <div class="date">
                        {{val.end_time}}到期
                    </div>
                    <div class="yue">
                        余额：{{val.coupon_price}}点
                    </div>
                </div>
            </li>
        </ul>
        <div class="page-absolute mark" :style="markStyle" @click="close"></div>
    </div>
</template>

<script>
export default {
    name: "TicketOrderSelectWindow",
    props: {
        _isShow: {
            type: Boolean,
            default: false
        },
        twoTypes: {
            type: Boolean,
            default: false
        },
        arr: {
            type: Array,
            default: ()=>[
                {
                    value: 1,
                    text: "身份证"
                }, {
                    value: 2,
                    text: "护照"
                }
            ]
        },
        addTextWords: {
            type: String,
            default: ""
        },
        markStyle: {
            type: Object,
            default: ()=>{}
        }
    },
    created: function () {
        // console.log(this.arr,"arr");
    },
    computed: {
        id_type_arr: function () {
            return this.arr;
        }
    },
    data: function() {
        return {
            checked_option: null
        }
    },
    methods: {
        checkedOption: function(val) {
            this.checked_option = val.value;
            this.$emit('checkedOption', val);
            
            let clear = setTimeout(()=>{
                this.close();
                clearTimeout(clear);
            }, 200);
        },
        close: function() {
            this.$emit('isShow', false);
        }
    }
}
</script>

<style scoped>
.select {
    top: 0;
    left: 0;
    z-index: 100;
}
.mark {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
    z-index: 110;
}
.select-option {
    line-height: .8rem;
    font-size: .32rem;
}
.circular {
    display: inline-block;
    width: .3rem;
    height: .3rem;
    border-radius: 50%;
    border: .02rem solid #ccc;
}
.checked-option {
    border: none;
    background: #2291f8;
}
.select-option-wrapper {
    width: 60%;
    z-index: 111;
    top: 50%;
    left: 50%;
    max-height: 5.6rem;
    overflow-y: auto;
    transform: translate(-50%, -50%);
    border-radius: .2rem;
}
.twoTypesStyle {
    width: 75%;
    max-height: 7rem;
}
.ciCard {
  height:2.5rem;
  width: 5rem;
  padding-top:0.5rem;
  background-image:url("../assets/images/ci.jpg");
  background-size:100% 100%;
  /* position: absolute; */
  position: relative;
}
.ciCard .cardNum
{

  position: relative;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  top: -0.35rem;
  left: 0.95rem;
  color: #fff;
  line-height:0.3rem;
  font-size: 0.2rem;
  width: 50%;
}
.ciCard .date
{

    position: relative;
    float: right;
    top: 0.18rem;
    right: 0.2rem;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #fff;
    position: absolute;
    font-size: 0.2rem;
}
.ciCard .yue
{
    margin: 0 auto;
    width: 100%;
    text-align: center;
    font-size: 0.38rem;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #E83627;
    top: 1.1rem;
    position: absolute;
}
.quan {
    top: 1.35rem;
    left: 0.45rem;
}
</style>